export const createQueryStringFromSearchParams = (params: URLSearchParams) =>
  params.toString() ? `?${params.toString()}` : '';

export type OverrideParams = {
  [key: string]: string | number | undefined;
};

export const resolveIncludeSoldAtFrom = () => {
  // Add includeSoldAtFrom parameter with date 5 days back
  const fiveDaysAgo = new Date();
  fiveDaysAgo.setDate(fiveDaysAgo.getDate() - 5);
  const includeSoldAtFrom = fiveDaysAgo.toISOString().split('T')[0];
  return includeSoldAtFrom;
};

export const createSearchParams = (
  params: URLSearchParams,
  overrideParams: OverrideParams = {},
) => {
  const _params = new URLSearchParams(params);

  // Only set hits if missing or above 24
  const hits = _params.get('hits');
  if (!hits || Number(hits) > 24) {
    _params.set('hits', '24');
  }

  _params.set('includeSoldAtFrom', resolveIncludeSoldAtFrom());

  Object.keys(overrideParams).forEach((key) => {
    if (key !== 'hits') {
      const value = overrideParams[key];
      if (value !== undefined) {
        _params.set(key, value.toString());
      }
    }
  });

  _params.sort();
  return { params, queryString: createQueryStringFromSearchParams(_params) };
};

export const concurrentMap = async <T, R>(
  arr: T[],
  limit: number,
  asyncFn: (item: T, idx: number) => Promise<R>,
): Promise<R[]> => {
  const results: R[] = [];
  let i = 0;
  const worker = async () => {
    while (i < arr.length) {
      const idx = i++;
      results[idx] = await asyncFn(arr[idx], idx);
    }
  };
  await Promise.all(Array.from({ length: limit }, worker));
  return results;
};
